import React, { Component } from 'react'

class CheckOutFailedPage extends Component {
    render() {
        return (
            <div className="container p-2 mb-2">
                <div className='bg-floralwhite p-2'>
                <p className="text-color pt-3 pb-3">
                    <h4>
                       Sorry! we can't complete your order this time 
                    </h4>
                </p>
                <p>
                    <strong>Something went wrong!</strong><br/>
                 we're working hard to resolve the issue, please try again letter or <a href="/Support/CustomerSupport">contact us</a> to get immediate help
                </p>

                <p>
                    For further information on what to do next please <a href="/Support/CustomerSupport">click here</a>
                </p>
                </div>
                

            </div>
        )
    }
}

export default CheckOutFailedPage
